import { z } from "zod";
const usernameSchema = z
    .string()
    .min(3)
    .max(32)
    .regex(/^[a-z0-9][a-z0-9._-]*$/, "Use minusculas, numeros, ponto, hifen ou sublinhado");
export const createTeamSchema = z.object({
    name: z.string().min(1).max(120),
    username: usernameSchema,
    /** Opcional: sem senha, o servidor gera uma e devolve em claro uma unica vez. */
    password: z.string().min(6).max(128).optional(),
    members: z.array(z.string().min(1).max(120)).max(10).default([]),
    institution: z.string().max(200).nullable().default(null),
    isOfficial: z.boolean().default(true),
});
export const updateTeamSchema = z
    .object({
    name: z.string().min(1).max(120).optional(),
    username: usernameSchema.optional(),
    members: z.array(z.string().min(1).max(120)).max(10).optional(),
    institution: z.string().max(200).nullable().optional(),
    isOfficial: z.boolean().optional(),
})
    .refine((v) => Object.keys(v).length > 0, {
    message: "Informe ao menos um campo para alterar",
});
export const bulkCreateTeamsSchema = z.object({
    count: z.number().int().positive().max(200),
    usernamePrefix: z
        .string()
        .min(1)
        .max(20)
        .regex(/^[a-z0-9]+$/, "Use apenas minusculas e numeros")
        .default("equipe"),
    namePrefix: z.string().min(1).max(60).default("Equipe"),
    isOfficial: z.boolean().default(true),
});
//# sourceMappingURL=teams.js.map